import {Modal, Spin, Table} from 'antd';
import React, {useRef, useState} from "react";
import useStatsDescTab from "./useStatsDescTab";
import Draggable from "react-draggable";
import {useTheme} from "../../context/ThemeContext";
import {useTranslation} from "react-i18next";

const StatsDescTab = ({isModalOpen, setIsModalOpen}) => {

    const { isDarkMode, toggleDarkMode } = useTheme();
    const {t} = useTranslation("dashboard");

    const [disabled, setDisabled] = useState(false);
    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });
    const draggleRef = useRef(null);
    const onStart = (_event, uiData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };
    const {selectedTypeColumn,tableHeader,data,rowSelection,loading,pagination,onRow,handleOk,handleCancel, groupTypeTitle} = useStatsDescTab(setIsModalOpen);
    return (
        <Modal
            footer={[]}
            title={
                <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        if (disabled) {
                            setDisabled(false);
                        }
                    }}
                    onMouseOut={() => {
                        setDisabled(true);
                    }}
                    onFocus={() => {}}
                    onBlur={() => {}}
                >
                    {t(groupTypeTitle)}
                </div>
            }
            modalRender={(modal) => (
            <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
            >
                <div ref={draggleRef}>{modal}</div>
            </Draggable>
        )}
            width={"350"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            {!loading ?
                <Table columns={selectedTypeColumn}
                           dataSource={data}
                           className={isDarkMode ? "table-striped-rows darkTheme" : "table-striped-rows"}
                       rowKey={selectedTypeColumn[0]["dataIndex"]}
                           rowSelection={rowSelection}
                           loading={loading}
                           title={tableHeader}
                           size='small'
                           scroll={{x: 300, y: 'calc(100vh - 350px)'}}
                           tableLayout="auto"
                           pagination={pagination}
                           onRow={onRow}
                    />
             : <Spin/>
            }
        </Modal>
    );
};

export default StatsDescTab;